// Collection page controller (vanilla, replaces the Alpine main-collection component).
// Owns: filter/sort/tab AJAX, popstate, the filter drawer / sort / chips / column UI,
// the email opt-in forms, and SEAMLESS infinite scroll (prefetch buffer, no skeletons).
(function () {
  var root = document.querySelector('[data-collection-root]');
  if (!root) return;

  var AB_VIEW = 'sl-E3DF7902';
  var cfg = {
    collectionUrl: root.getAttribute('data-collection-url') || '/',
    defaultSort: root.getAttribute('data-default-sort') || 'manual',
    suffix: root.getAttribute('data-template-suffix') || ''
  };

  var state = {
    sortBy: root.getAttribute('data-sort-by') || cfg.defaultSort,
    currentUrl: window.location.href,
    pendingFilters: new Set(),
    fetchedUrls: new Set(),
    chunks: [],
    bufferNextUrl: null,
    fetching: false,
    isLoading: false,
    observer: null
  };

  // ---------- helpers ----------
  function origin() { return window.location.origin; }
  function fetchDoc(url, opts) {
    return fetch(url, opts || {}).then(function (r) { return r.text(); }).then(function (html) {
      return new DOMParser().parseFromString(html, 'text/html');
    });
  }
  function extractNextUrl(doc) {
    if (!doc) return null;
    var el = doc.querySelector('[data-pagination] [data-next-url]');
    if (el && el.getAttribute('data-next-url')) return el.getAttribute('data-next-url');
    var a = doc.querySelector('[data-pagination] a[rel=next]') ||
            doc.querySelector("[data-pagination] a[aria-label*='next']") ||
            doc.querySelector("[data-pagination] a[href*='page=']");
    return a ? a.href : null;
  }
  function isABActive(u) {
    try {
      var view = new URL(u || state.currentUrl || window.location.href).searchParams.get('view');
      return view === AB_VIEW || cfg.suffix === AB_VIEW;
    } catch (e) { return false; }
  }
  function setStockConfig(c, url) {
    window.__stockMeterConfig = isABActive(url) ? Object.assign({ enabled: false }, c || {}) : { enabled: false };
    document.dispatchEvent(new CustomEvent('tnc:stock-config', { detail: window.__stockMeterConfig }));
  }
  function buildTabUrl(raw) {
    try {
      var out = new URL(raw, origin());
      new URL(window.location.href).searchParams.forEach(function (v, k) {
        if (k === 'page' || k.indexOf('filter.') === 0) return;
        out.searchParams.set(k, v);
      });
      return out.toString();
    } catch (e) { return raw; }
  }
  function keptParams(extraSort) {
    var params = new URLSearchParams();
    new URL(state.currentUrl, origin()).searchParams.forEach(function (v, k) {
      if (k === 'page' || k.indexOf('filter.') === 0) return;
      params.set(k, v);
    });
    if (extraSort && state.sortBy && state.sortBy !== cfg.defaultSort) params.set('sort_by', state.sortBy);
    return params;
  }

  // ---------- active-filter counters + drawer UI ----------
  function countFilters(url) {
    var n = 0;
    try {
      var u = new URL(url, origin());
      u.searchParams.forEach(function (_v, k) { if (k.indexOf('filter.') === 0) n++; });
      var parts = u.pathname.split('/');
      if (parts.length > 3 && parts[3]) n += parts[3].split('+').length;
      if (state.sortBy && state.sortBy !== cfg.defaultSort && state.sortBy !== 'best-selling') n++;
    } catch (e) {}
    return n;
  }
  function refreshUI() {
    var active = countFilters(state.currentUrl);
    var pending = state.pendingFilters.size;
    each('[data-active-filter-count]', function (el) { el.textContent = active; });
    each('[data-chips]', function (el) { el.hidden = active <= 0; });
    each('[data-pending-count]', function (el) {
      var n = Math.max(active, pending);
      el.hidden = n <= 0;
      el.textContent = n;
    });
    each('[data-clear-filters]', function (el) { el.disabled = active === 0 && pending === 0; });
    each('[data-apply-label]', function (el) {
      el.textContent = pending > 0 ? ('Apply ' + pending + ' filter' + (pending === 1 ? '' : 's')) : el.getAttribute('data-default-label');
    });
    syncFilterControls();
    setSortLabel();
    initPriceSliders();
  }
  function syncFilterControls() {
    each('[data-filter-toggle]', function (el) {
      el.classList.toggle('is-checked', state.pendingFilters.has(el.getAttribute('data-filter-toggle')));
    });
    each('[data-price-filter]', function (el) {
      var add = (el.getAttribute('data-price-add') || '').split(',').filter(Boolean);
      var on = add.length > 0 && add.every(function (p) { return state.pendingFilters.has(p); });
      el.classList.toggle('is-selected', on);
    });
  }
  function setSortLabel() {
    var menu = document.querySelector('[data-sort]');
    if (!menu) return;
    var opt = menu.querySelector('[data-sort-option="' + cssEsc(state.sortBy) + '"]');
    var label = menu.querySelector('[data-sort-label]');
    if (label) label.textContent = opt ? (opt.getAttribute('data-sort-text') || opt.textContent.trim()) : (menu.getAttribute('data-sort-default') || 'Featured');
    each('[data-sort-option]', function (el) { el.classList.toggle('is-active', el.getAttribute('data-sort-option') === state.sortBy); });
  }

  function markActiveTab() {
    var tabs = document.querySelectorAll('[data-tab]');
    if (!tabs.length) return;
    var cur = new URL(state.currentUrl, origin()).pathname.replace(/\/+$/, '');
    var best = null;
    Array.prototype.forEach.call(tabs, function (t) {
      t.classList.remove('is-active');
      try {
        var p = new URL(buildTabUrl(t.getAttribute('data-tab')), origin()).pathname.replace(/\/+$/, '');
        if (cur === p || cur.indexOf(p + '/') === 0) { if (!best || p.length > best.p.length) best = { el: t, p: p }; }
      } catch (e) {}
    });
    if (best) best.el.classList.add('is-active');
  }

  // ---------- pending filters <-> url ----------
  function syncPendingFromUrl() {
    state.pendingFilters.clear();
    try {
      var u = new URL(state.currentUrl, origin());
      u.searchParams.forEach(function (v, k) { if (k.indexOf('filter.') === 0) state.pendingFilters.add(k + '=' + v); });
      var parts = u.pathname.split('/');
      if (parts.length > 3 && parts[3]) parts[3].split('+').forEach(function (t) { if (t) state.pendingFilters.add(t); });
    } catch (e) {}
  }

  // ---------- AJAX collection swap ----------
  function fetchCollection(url, updateHistory) {
    if (state.isLoading) return;
    state.isLoading = true;
    setLoader(true);
    resetInfinite();
    return fetchDoc(url, { credentials: 'same-origin' }).then(function (doc) {
      if (updateHistory !== false) window.history.pushState({}, '', url);
      state.currentUrl = url;
      try { state.sortBy = new URL(url, origin()).searchParams.get('sort_by') || cfg.defaultSort; } catch (e) {}

      swapInner('[data-product-grid]', doc);
      swapInner('[data-pagination]', doc);
      swapInner('[data-collection-filters]', doc);
      var na = doc.querySelector('[data-applied-filters]');
      if (na) each('[data-applied-filters]', function (el) { el.innerHTML = na.innerHTML; });
      var nc = doc.querySelector('[data-product-count]');
      var cc = document.querySelector('[data-product-count]');
      if (nc && cc) cc.textContent = nc.textContent;

      document.dispatchEvent(new CustomEvent('tnc:stock-config', { detail: window.__stockMeterConfig || { enabled: false } }));
      syncPendingFromUrl();
      refreshUI();
      markActiveTab();
      state.bufferNextUrl = extractNextUrl(doc);

      // Applying a filter / sort / tab / page → smooth-scroll back up to the results.
      var top = document.querySelector('[data-collection-top]');
      if (top) top.scrollIntoView({ behavior: 'smooth' });
    }).catch(function (e) { /* noop */ }).then(function () {
      state.isLoading = false;
      setLoader(false);
      setupSentinel();
      fillBuffer();
      tick();
    });
  }
  function swapInner(sel, doc) {
    var nu = doc.querySelector(sel), cur = document.querySelector(sel);
    if (nu && cur) cur.innerHTML = nu.innerHTML;
  }
  function setLoader(on) { each('[data-collection-loader]', function (el) { el.hidden = !on; }); }

  // ---------- seamless infinite scroll ----------
  function currentGrid() { return document.querySelector('[data-product-grid] .grid'); }
  function appendCards(cards) {
    var grid = currentGrid();
    if (!grid || !cards || !cards.length) return;
    var seen = new Set();
    grid.querySelectorAll('[data-product-card] [data-product-id]').forEach(function (el) {
      var id = el.getAttribute('data-product-id'); if (id) seen.add(id);
    });
    var frag = document.createDocumentFragment();
    cards.forEach(function (card) {
      var idEl = card.querySelector('[data-product-id]');
      var id = idEl ? idEl.getAttribute('data-product-id') : null;
      if (!id || !seen.has(id)) { frag.appendChild(card.cloneNode(true)); if (id) seen.add(id); }
    });
    grid.appendChild(frag);
  }
  var LOOKAHEAD = 1;           // pages kept pre-fetched in memory, ready to append instantly
  var NEAR = 1400;            // px below the viewport that counts as "near the sentinel"
  function sentinelNear() {
    var s = document.querySelector('[data-infinite-sentinel]');
    if (!s) return false;
    return s.getBoundingClientRect().top < window.innerHeight + NEAR;
  }
  // Background prefetch: keep up to LOOKAHEAD pages buffered. Self-chains until full or end.
  function fillBuffer() {
    if (state.fetching || !state.bufferNextUrl || state.chunks.length >= LOOKAHEAD) return;
    var url = state.bufferNextUrl;
    if (state.fetchedUrls.has(url)) return;
    state.fetchedUrls.add(url);
    state.fetching = true;
    fetchDoc(url).then(function (doc) {
      state.chunks.push(Array.prototype.slice.call(doc.querySelectorAll('[data-product-grid] [data-product-card]')));
      state.bufferNextUrl = extractNextUrl(doc);
      state.fetching = false;
      fillBuffer();   // top up toward LOOKAHEAD
      tick();         // user may already be waiting at the bottom
    }).catch(function () { state.fetchedUrls.delete(url); state.fetching = false; });
  }
  // Drain buffered pages instantly while the sentinel is in range; never blocks on the network.
  function tick() {
    if (state.isLoading) return;
    while (state.chunks.length && sentinelNear()) appendCards(state.chunks.shift());
    if (state.bufferNextUrl) fillBuffer();
    else if (!state.chunks.length) disconnectSentinel();
  }
  function setupSentinel() {
    disconnectSentinel();
    var sentinel = document.querySelector('[data-infinite-sentinel]');
    if (!sentinel) return;
    state.observer = new IntersectionObserver(function (entries) {
      if (entries[0] && entries[0].isIntersecting) tick();
    }, { rootMargin: NEAR + 'px 0px', threshold: 0 });
    state.observer.observe(sentinel);
  }
  function disconnectSentinel() { if (state.observer) { state.observer.disconnect(); state.observer = null; } }
  function resetInfinite() { disconnectSentinel(); state.fetchedUrls.clear(); state.chunks = []; state.fetching = false; state.bufferNextUrl = null; }

  // ---------- sort / filter actions ----------
  function updateSortAndFilter(val) {
    if (val === 'available-true') { togglePending('filter.v.availability=1'); applyFilters(); return; }
    try {
      var u = new URL(state.currentUrl, origin());
      u.searchParams.set('sort_by', val);
      state.sortBy = val;
      fetchCollection(u.toString());
    } catch (e) {}
  }
  function togglePending(f) { if (state.pendingFilters.has(f)) state.pendingFilters.delete(f); else state.pendingFilters.add(f); }
  function clearAllFilters() { state.pendingFilters.clear(); state.sortBy = cfg.defaultSort; fetchCollection(cfg.collectionUrl); }
  function applyFilters() {
    var tags = [], queries = [];
    state.pendingFilters.forEach(function (f) { (f.indexOf('filter.v.') !== -1 || f.indexOf('=') !== -1) ? queries.push(f) : tags.push(f); });
    var url = cfg.collectionUrl + (tags.length ? '/' + tags.join('+') : '');
    var params = keptParams(true);
    queries.forEach(function (q) { var i = q.indexOf('='); if (i > -1) params.set(q.slice(0, i), q.slice(i + 1)); });
    var qs = params.toString();
    if (qs) url += (url.indexOf('?') !== -1 ? '&' : '?') + qs;
    fetchCollection(url);
  }
  function toggleTagFilter(val) {
    var path = new URL(state.currentUrl, origin()).pathname, tags = [];
    var parts = path.split('/');
    if (parts.length > 3 && parts[3]) tags = parts[3].split('+');
    var i = tags.indexOf(val);
    if (i !== -1) tags.splice(i, 1); else tags.push(val);
    var url = cfg.collectionUrl + (tags.length ? '/' + tags.join('+') : '');
    var params = keptParams(true);
    var qs = params.toString();
    if (qs) url += (url.indexOf('?') !== -1 ? '&' : '?') + qs;
    fetchCollection(url);
  }
  function clearPriceFilters() {
    state.pendingFilters.forEach(function (f) { if (f.indexOf('filter.v.price.') === 0) state.pendingFilters.delete(f); });
  }

  // ---------- price range slider ----------
  function psBounds(s) {
    var lo = +s.querySelector('[data-ps-min]').value;
    var hi = +s.querySelector('[data-ps-max]').value;
    return lo <= hi ? [lo, hi] : [hi, lo];
  }
  function syncPriceSlider(s, moved) {
    var floor = +s.getAttribute('data-min');
    var ceil = +s.getAttribute('data-max') || 1;
    var minEl = s.querySelector('[data-ps-min]');
    var maxEl = s.querySelector('[data-ps-max]');
    if (!minEl || !maxEl) return;
    // keep the two handles from crossing
    if (moved === minEl && +minEl.value > +maxEl.value) minEl.value = maxEl.value;
    if (moved === maxEl && +maxEl.value < +minEl.value) maxEl.value = minEl.value;
    var b = psBounds(s), lo = b[0], hi = b[1];
    var span = (ceil - floor) || 1;
    var range = s.querySelector('[data-ps-range]');
    if (range) {
      range.style.left = ((lo - floor) / span * 100) + '%';
      range.style.width = ((hi - lo) / span * 100) + '%';
    }
    var ll = s.querySelector('[data-ps-min-label]'), hl = s.querySelector('[data-ps-max-label]');
    if (ll) ll.textContent = '$' + lo;
    if (hl) hl.textContent = '$' + hi + (hi >= ceil ? '+' : '');
  }
  function applyPriceSlider(s) {
    var floor = +s.getAttribute('data-min'), ceil = +s.getAttribute('data-max');
    var b = psBounds(s), lo = b[0], hi = b[1];
    clearPriceFilters();
    if (lo > floor) state.pendingFilters.add(s.getAttribute('data-param-gte') + '=' + lo);
    if (hi < ceil) state.pendingFilters.add(s.getAttribute('data-param-lte') + '=' + hi);
    refreshUI();
    if (isDesktop() && s.closest('[data-filter-drawer], [data-filter-bar]')) applyFilters();
  }
  function initPriceSliders() { each('[data-price-slider]', function (s) { syncPriceSlider(s); }); }

  // ---------- drawer + dropdowns ----------
  function openDrawer() {
    var d = document.querySelector('[data-filter-drawer]');
    if (!d) return;
    d.hidden = false;
    document.body.classList.add('overflow-hidden');
    refreshUI();
  }
  function closeDrawer() {
    var d = document.querySelector('[data-filter-drawer]');
    if (d) d.hidden = true;
    document.body.classList.remove('overflow-hidden');
  }
  function closeMenus(except) {
    each('[data-sort-menu],[data-chips-menu]', function (el) { if (el !== except) el.hidden = true; });
  }

  // ---------- mobile column toggle ----------
  function applyCols(n) {
    document.documentElement.classList.toggle('tc-cols-1', n === 1);
    each('[data-cols-set]', function (el) { el.classList.toggle('is-active', +el.getAttribute('data-cols-set') === n); });
  }
  // ---------- desktop column toggle (3 vs 4) ----------
  function applyColsDesktop(n) {
    document.documentElement.classList.toggle('tc-dcols-4', n === 4);
    each('[data-cols-desktop-set]', function (el) { el.classList.toggle('is-active', +el.getAttribute('data-cols-desktop-set') === n); });
  }

  // ---------- email opt-in ----------
  function submitOptin(form) {
    var email = (form.querySelector('[data-optin-email]') || {}).value || '';
    var prefs = Array.prototype.slice.call(form.querySelectorAll('[data-optin-pref].is-selected')).map(function (b) { return b.getAttribute('data-optin-pref'); });
    var errEl = form.querySelector('[data-optin-error]');
    if (!email || !prefs.length) { if (errEl) { errEl.textContent = 'Please enter email and select at least one preference'; errEl.hidden = false; } return; }
    if (errEl) errEl.hidden = true;
    var handle = form.getAttribute('data-optin') || '';
    try {
      if (typeof window._learnq !== 'undefined') {
        window._learnq.push(['identify', { '$email': email, 'preferences': prefs.join(','), 'source': 'collection_email_optin', 'collection': handle }]);
      }
    } catch (e) {}
    var fd = new FormData();
    fd.append('email', email); fd.append('g', 'JZBVtt'); fd.append('$fields', 'preferences,source,collection');
    fd.append('preferences', prefs.join(',')); fd.append('source', 'collection_email_optin'); fd.append('collection', handle);
    fetch('https://manage.kmail-lists.com/ajax/subscriptions/subscribe', { method: 'POST', body: fd, mode: 'no-cors' }).then(done).catch(done);
    function done() {
      var body = form.querySelector('[data-optin-body]'), ok = form.querySelector('[data-optin-success]');
      if (body) body.hidden = true;
      if (ok) ok.hidden = false;
    }
  }

  // ---------- event delegation ----------
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.closest) return;
    var el;

    if ((el = t.closest('[data-open-filter-drawer]'))) { openDrawer(); return; }
    if ((el = t.closest('[data-close-filter-drawer]'))) { closeDrawer(); return; }
    if ((el = t.closest('[data-clear-filters]'))) { clearAllFilters(); closeDrawer(); return; }
    if ((el = t.closest('[data-apply-filters]'))) { applyFilters(); closeDrawer(); return; }

    if ((el = t.closest('[data-sort-option]'))) { updateSortAndFilter(el.getAttribute('data-sort-option')); closeMenus(); return; }
    if ((el = t.closest('[data-sort-toggle]'))) { var m = document.querySelector('[data-sort-menu]'); var open = m && m.hidden; closeMenus(); if (m) m.hidden = !open; e.stopPropagation(); return; }
    if ((el = t.closest('[data-chips-toggle]'))) { var cm = document.querySelector('[data-chips-menu]'); var o2 = cm && cm.hidden; closeMenus(); if (cm) cm.hidden = !o2; e.stopPropagation(); return; }

    if ((el = t.closest('[data-cols-set]'))) {
      var n = +el.getAttribute('data-cols-set');
      try { localStorage.setItem('tc_collection_mobile_cols', n); } catch (er) {}
      applyCols(n); return;
    }
    if ((el = t.closest('[data-cols-desktop-set]'))) {
      var nd = +el.getAttribute('data-cols-desktop-set');
      try { localStorage.setItem('tc_collection_desktop_cols', nd); } catch (er) {}
      applyColsDesktop(nd); return;
    }

    if ((el = t.closest('[data-tab]'))) {
      e.preventDefault();
      var url = buildTabUrl(el.getAttribute('data-tab'));
      var stock = {};
      try { stock = JSON.parse(el.getAttribute('data-tab-stock') || '{}'); } catch (er) {}
      setStockConfig(stock, url);
      state.currentUrl = url;
      each('[data-tab]', function (x) { x.classList.remove('is-active'); });
      el.classList.add('is-active');
      fetchCollection(url);
      return;
    }

    if ((el = t.closest('[data-fetch-url]'))) { e.preventDefault(); fetchCollection(el.getAttribute('data-fetch-url')); return; }

    if ((el = t.closest('[data-accordion-toggle]'))) { var acc = el.closest('[data-accordion]'); if (acc) acc.classList.toggle('is-open'); return; }

    if ((el = t.closest('[data-filter-toggle]'))) {
      e.preventDefault();
      var f = el.getAttribute('data-filter-toggle');
      togglePending(f);
      el.classList.toggle('is-checked', state.pendingFilters.has(f));
      refreshUI();
      if (isDesktop() && el.closest('[data-filter-drawer], [data-filter-bar]')) applyFilters();
      return;
    }
    if ((el = t.closest('[data-price-filter]'))) {
      e.preventDefault();
      clearPriceFilters();
      (el.getAttribute('data-price-add') || '').split(',').filter(Boolean).forEach(function (p) { state.pendingFilters.add(p); });
      refreshUI();
      if (isDesktop() && el.closest('[data-filter-drawer], [data-filter-bar]')) applyFilters();
      return;
    }

    if ((el = t.closest('[data-optin-pref]'))) { el.classList.toggle('is-selected'); return; }
    if ((el = t.closest('[data-optin-submit]'))) { var form = el.closest('[data-optin]'); if (form) submitOptin(form); return; }

    // click-away for menus
    if (!t.closest('[data-sort]') && !t.closest('[data-chips]')) closeMenus();
  });

  document.addEventListener('input', function (e) {
    var el = e.target; if (!el || !el.closest) return;
    var s = el.closest('[data-price-slider]');
    if (s) syncPriceSlider(s, el);
  });
  document.addEventListener('change', function (e) {
    var el = e.target; if (!el || !el.closest) return;
    var s = el.closest('[data-price-slider]');
    if (s && (el.hasAttribute('data-ps-min') || el.hasAttribute('data-ps-max'))) applyPriceSlider(s);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeMenus(); closeDrawer(); }
  });

  window.addEventListener('popstate', function () { state.currentUrl = window.location.href; fetchCollection(state.currentUrl, false); });

  // Scroll fallback: a safety net in case the observer misses a fast fling.
  var scrollTick = false;
  window.addEventListener('scroll', function () {
    if (scrollTick) return;
    scrollTick = true;
    requestAnimationFrame(function () { scrollTick = false; tick(); });
  }, { passive: true });

  // ---------- small utils ----------
  function each(sel, fn) { Array.prototype.forEach.call(document.querySelectorAll(sel), fn); }
  function cssEsc(s) { return String(s).replace(/"/g, '\\"'); }
  function isDesktop() { try { return window.matchMedia('(min-width: 1024px)').matches; } catch (e) { return false; } }

  // ---------- init ----------
  try {
    var u = new URL(state.currentUrl, origin());
    state.sortBy = u.searchParams.get('sort_by') || state.sortBy;
  } catch (e) {}
  try { applyCols(localStorage.getItem('tc_collection_mobile_cols') === '1' ? 1 : 2); } catch (e) {}
  try { applyColsDesktop(localStorage.getItem('tc_collection_desktop_cols') === '3' ? 3 : 4); } catch (e) {}
  syncPendingFromUrl();
  refreshUI();
  markActiveTab();

  // Move the fixed overlays to <body> so position:fixed escapes any transformed ancestor
  // (full-screen drawer/loader on every breakpoint — the filter opens from the toolbar pill).
  ['[data-filter-drawer]', '[data-collection-loader]'].forEach(function (sel) {
    var el = document.querySelector(sel);
    if (el && el.parentNode !== document.body) document.body.appendChild(el);
  });

  state.bufferNextUrl = extractNextUrl(document);
  setupSentinel();
  fillBuffer();
  tick();
})();
